import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Shadows } from '../../../../play-core/styles/Shadows';
import { jsx as _jsx } from "react/jsx-runtime";
export const Marble = ({
  children,
  expand = false,
  onClick = () => {},
  isActive = false,
  ...props
}) => /*#__PURE__*/_jsx(StyledActionItem, {
  onClick: onClick,
  expand: expand,
  isActive: isActive,
  ...props,
  children: /*#__PURE__*/_jsx(ActionItem, {
    children: children
  })
});
const StyledActionItem = styled.div.withConfig({
  displayName: "Marble__StyledActionItem",
  componentId: "sc-a6t6o-0"
})(["height:48px;background-color:", ";", ";border-radius:28px;min-width:48px;width:", ";", ";color:", ";transition:all 200ms ease-in;", "{&:hover{", ";background-color:", ";}}&:not(:first-child){margin-left:24px;}"], ({
  isActive
}) => isActive ? Colors.SRF_cac8bf : Colors.SRF_fafaf8, ({
  isActive
}) => isActive ? Shadows.applyDouble(8) : Shadows.applyDouble(2), ({
  expand
}) => expand ? '100%' : 'auto', Fonts.regular(16), Colors.SRF_4e4d47, Device.mouse, Shadows.applyDouble(8), Colors.SRF_ebebe5);
const ActionItem = styled.div.withConfig({
  displayName: "Marble__ActionItem",
  componentId: "sc-a6t6o-1"
})(["height:100%;display:flex;justify-content:center;align-items:center;cursor:pointer;"]);
export const MarbleLink = styled.a.withConfig({
  displayName: "Marble__MarbleLink",
  componentId: "sc-a6t6o-2"
})(["height:100%;display:flex;justify-content:center;align-items:center;width:100%;font-size:24px;color:", ";"], Colors.SRF_4e4d47);